import { ApplicationConfig, provideZoneChangeDetection } from "@angular/core";
import { PreloadAllModules, provideRouter, withPreloading } from "@angular/router";

import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideTranslateService } from "@ngx-translate/core";
import {
  CommonService,
  httpRequestWithCredentialsInterceptor,
  initializeGastTranslationService,
  provideEnvFile,
  StaticCommonService,
  withGastTranslateConfig
} from "gast-common-ng2";
import { BsModalService } from "ngx-bootstrap/modal";
import { provideToastr } from "ngx-toastr";
import { routes } from "./app.routes";

declare const PRODUCT_STAGE: string | undefined;

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(
      withInterceptors([httpRequestWithCredentialsInterceptor])
    ),
    provideEnvFile(PRODUCT_STAGE),
    provideTranslateService(withGastTranslateConfig([
      './common-assets/i18n/',
      './portal-assets/i18n/',
      './onset-assets/i18n/',
      './assets/i18n/'])),
    initializeGastTranslationService(),
    provideAnimations(),
    provideToastr(),
    { provide: CommonService, useClass: StaticCommonService },
    BsModalService,
  ],
};
